import { Component, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef
} from '@angular/material/dialog';
import { ModalDialogData } from '../../../tournament/models/tournaments.interface';

@Component({
    selector: 'app-non-closable-modal',
    templateUrl: './non-closable-modal.component.html',
    styleUrls: ['./non-closable-modal.component.scss'],
})
export class NonClosableModalComponent {
    data = inject<ModalDialogData>(MAT_DIALOG_DATA);
    private dialogRef = inject<MatDialogRef<NonClosableModalComponent>>(MatDialogRef);

    constructor() {
        this.dialogRef.disableClose = this.data?.disableClose
    }


    copyLink(){
        navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!');
    }

    openInBrowser(){
        const isAndroid = /Mobi|Android/i.test(navigator.userAgent);
        const isIOS = /Mobi|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const url = new URL(window.location.href);
        const intentUriAndroid = `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=${url.protocol.replace(':', '')};package=com.android.chrome;end`;
        const intentUriIOS = `x-safari-https://${url.host}${url.pathname}${url.search}`;
        window.open(isAndroid ? intentUriAndroid : intentUriIOS, '_system');
    }
}
